import { apiGet, apiPost } from "app/services/apiServices";
import type { CellEditingStartedEvent } from "ag-grid-community";
import { AgTableClient } from "app/shared/AgTable";
import { useEffect, useRef, useState } from "react";
import {
  API_ENDPOINT_EMAIL_CREDENTIAL_MAP,
  API_ENDPOINT_FETCH_CLUSTOR_EMAIL_LIST,
  API_ENDPOINT_FETCH_EMAIL_CREDENTIALS_LIST,
  API_ENDPOINT_EMAIL_CREDENTIAL_MAPBULK,
  API_ENDPOINT_EMAIL_ADD_NEW
} from "../../credentials.constants";
import Loader from "app/shared/Loader";
import _isEqual from "lodash/isEqual";
import {
  CheckCircleFilled,
  CloseCircleFilled,
  PlusOutlined,
  ExportOutlined,
  ExclamationCircleFilled,
  SearchOutlined,
  LoadingOutlined 
} from "@ant-design/icons";
import { Button, Empty, Modal, Spin, message ,Tag,Segmented,Input} from "antd";
import SearchInput from "app/shared/SearchInput";
import CreateEmail from "./components/CreateEmail";
import AgTableEditButton from "app/shared/AgTable/AgTableClient/HelperTools/EditComponent";
import { useRecoilState } from "recoil";
import { userInfo } from "app/config/States/users";
import PageHeader from "app/shared/PageHeader";
import { Mixpanel } from "app/config/Mixpanel";
import DownloadDoneIcon from "@mui/icons-material/DownloadDone";
import DownloadIcon from "@mui/icons-material/Download";
import Uploader from "app/shared/Uploader";
import * as XLSX from "xlsx";
import csv from "csvtojson";
import FileUploadIcon from "@mui/icons-material/FileUpload";
import _cloneDeep from "lodash/cloneDeep";
import axios from "axios";
import { match } from "assert";

export default function EmailCredentials(props: any) {
  const [tableData, setTableData] = useState<any[]>([]);
  const [isLoading, setLoading] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [emailList, setEmailList] = useState([]);
  const [messageApi, contextHolder] = message.useMessage();
  const [userDetails, _] = useRecoilState<any>(userInfo);
  const [isBulkModalVisible, setIsBulkModalVisible] = useState(false); //new---
  const [uploadedFile, setUploadedFile] = useState<File | null>(null); //new
  const [uploadedData, setUploadedData] = useState<any[]>([]); //new
  const [originalData, setOriginalData] = useState<any[]>([]);
  const [panList, setPanList] = useState<any[]>([]);
  const [filteredPANS, setFilteredPANS] = useState<any[]>([]);
  const [isRowAdded, setIsRowAdded] = useState(false);
  const [gridApi, setGridApi] = useState<any>(null);
  const [integrating, setIntegrating] = useState(false);
  const gridRef = useRef<any>(null);
  const gridApiRef = useRef<any>(null);
  const [refreshTimerId, setRefreshTimerId] = useState<ReturnType<
    typeof setInterval
  > | null>(null);
  const [activeSegment, setActiveSegment] = useState("FAILED");
  const [globalSearch, setGlobalSearch] = useState("");
  const [isEditMode, setIsEditMode] = useState(false);
const [editingData, setEditingData] = useState<any>(null);
const [showResolutionPopup, setShowResolutionPopup] = useState(false);
const [resolvedRows, setResolvedRows] = useState<any[]>([]);


  const handleEditClick = (rowData: any) => {
    setEditingData(rowData);
    setIsEditMode(true);
    setShowModal(true);
  };
  const handleCreateSuccess = () => {
    setShowModal(false);
    setIsEditMode(false);
    setEditingData(null);
    fetchEmailCredentials();
  };
  const handleModalClose = () => {
    setShowModal(false);
    setIsEditMode(false);
    setEditingData(null);
  };



  const columnDefs = [
    // {
    //   field: "service_provider",
    //   headerName: "Service Provider",
    //   enableRowGroup: true,
    //   minWidth: 200,
    //   filter: "agTextColumnFilter",
    //   cellRenderer:(params:any)=>{
    //     return(
    //       <div>

    //       </div>
    //     )
    //   }
    // },
    {
      field: "workspace",
      headerName: "Worksapce",
      enableRowGroup: true,
      minWidth: 200,
      filter: "agTextColumnFilter",
    },
    {
      field: "email",
      headerName: "Email",
      enableRowGroup: true,
      minWidth: 200,
      filter: "agTextColumnFilter",
    },
    {
      field: "email_password",
      headerName: "Password",
      enableRowGroup: true,
      minWidth: 200,
      filter: "agTextColumnFilter",
    },
    // {
    //   field: "email_password",
    //   headerName: "Password",
    //   enableRowGroup: true,
    //   minWidth: 200,
    //   filter: "agTextColumnFilter",
    //   editable: () => true,
    
    //   // Masking logic for displaying password
    //   cellRenderer: (params: any) => {
    //     const rawValue = params.value;
    
    //     // If the value is empty/null/undefined
    //     const isEmpty = rawValue === null || rawValue === undefined || rawValue === "" || rawValue === 0;
    //     if (isEmpty) {
    //       return '<span style="color: #aaa;">Enter password</span>';
    //     }
    
    //     const value = String(rawValue);
    //     const visiblePart = value.slice(-3); // last 3 characters
    //     const maskedPart = "*".repeat(Math.max(0, value.length - 3));
    
    //     return maskedPart + visiblePart;
    //   },
    // },
    

    {
      field: "gmail_app_password",
      headerName: "App Code",
      enableRowGroup: true,
      minWidth: 200,
      filter: "agTextColumnFilter",
     
    },

    // {
    //   field: "ssr_email",
    //   headerName: "SSR Email",
    //   enableRowGroup: true,
    //   minWidth: 200,
    //   editable: () => true,
    //   filter: "agTextColumnFilter",
    //   // valueFormatter: (params:any) => params.value || "Enter SSR email",
    //   cellRenderer: (params: any) => {
    //     const isEmpty = !params.value;
    //     return (
    //       <span style={{ color: isEmpty ? "#aaa" : "#000" }}>
    //         {isEmpty ? "Enter SSR email" : params.value}
    //       </span>
    //     );
    //   },
    // },

    // {
    //   field: "email",
    //   headerName: "Email",
    //   enableRowGroup: true,
    //   minWidth: 240,
    //   editable: true,
    //   filter: "agTextColumnFilter",
    //   cellRenderer: (params: any) => {
    //     const value = params.data?.email || params.data?.email_login_pid;
    //     const isEmpty = !value;
    //     return (
    //       <span style={{ color: isEmpty ? "#aaa" : "#000" }}>
    //         {isEmpty ? "Enter email" : value}
    //       </span>
    //     );
    //   },

    //   valueGetter: (params: any) => {
    //     return params.data?.email
    //       ? params.data?.email
    //       : params.data?.email_login_pid;
    //   },
    //   cellEditor: "agSelectCellEditor",
    //   cellEditorParams: {
    //     values: emailList.map((option: any) => option.email),
    //   },
    // },
    

    {
      field: "status",
      headerName: "Status",
      enableRowGroup: true,
      minWidth: 200,
      valueGetter: (params: any) => {
        const rawStatus = params.data?.status;
        const emailPassword = params.data?.email_password;
    
        if (rawStatus === "SUCCESS") {
          return "Valid";
        }
    
        if (rawStatus === "FAILED_LOGIN") {
          if (emailPassword === null || emailPassword === "" || emailPassword === undefined) {
            return "Not Available";
          } else {
            return "Wrong Credential";
          }
        }
    
        // if (rawStatus === "PENDING") {
        //   return "Pending";
        // }
    
        return "Not Available";
      },
      cellRenderer: (params: any) => {
        if (params?.node?.group) {
          return "";
        }
        const status = params.value;
        if (status === "Valid") {
          return (
            <Tag
              icon={<CheckCircleFilled />}
              color="success"
              style={{ display: "flex", alignItems: "center", gap: 4 }}
            >
              Valid
            </Tag>
          );
        }
        if (status === "Wrong Credential") {
          return (
            <Tag
              icon={<CloseCircleFilled />}
              color="error"
              style={{ display: "flex", alignItems: "center", gap: 4 }}
            >
              Wrong Credential
            </Tag>
          );
        }
        // if (status === "Pending") {
        //   return (
        //     <Tag
        //       icon={<LoadingOutlined />}
        //       color="processing" // 👈 blue spinner style
        //       style={{ display: "flex", alignItems: "center", gap: 4 }}
        //     >
        //       Pending
        //     </Tag>
        //   );
        // }
        return (
          <Tag
            icon={<ExclamationCircleFilled />}
            color="warning"
            style={{ display: "flex", alignItems: "center", gap: 4 }}
          >
            Not Available
          </Tag>
        );
      },
      filter: "agSetColumnFilter",
      filterParams: {
        values: ["Valid", "Wrong Credential", "Pending", "Not Available"], // 👈 Added "Pending" here
      },
    },
    {
      headerName: "Action",
      minWidth: 120,
      maxWidth: 120,
      sortable: false,
      filter: false,
      cellRenderer: (params: any) => {
        return (
          <Button
            type="primary"
            size="small"
            onClick={() => handleEditClick(params.data)}
            style={{
              backgroundColor: '#0A8394',
              borderColor: '#0A8394',
              fontSize: '12px',
              height: '28px',
              padding: '0 12px'
            }}
          >
            Edit
          </Button>
        );
      },
    },
    
    
  ];

  useEffect(() => {
    Mixpanel.track("User Landed On Email Integration Page", {
      Screen: "Email Integration Page",
    });

    fetchEmailCredentials();
    fetchEmailsForCluster();
  }, [userDetails.currentWorkspace]);

  const startAutoRefresh = () => {
    if (refreshTimerId) clearInterval(refreshTimerId);
  
    const id = setInterval(() => {
      fetchEmailCredentials(true); // pass isAutoRefresh = true
    }, 20000);
  
    setRefreshTimerId(id);
  };
  

  const stopAutoRefresh = () => {
    if (refreshTimerId) {
      clearInterval(refreshTimerId);
      setRefreshTimerId(null);
    }
  };

  useEffect(() => {
    return () => {
      if (refreshTimerId) {
        clearInterval(refreshTimerId);
        setRefreshTimerId(null);
      }
    };
  }, [refreshTimerId]);

  // const fetchEmailsForCluster = async () => {
  //   const response = await apiGet(API_ENDPOINT_FETCH_CLUSTOR_EMAIL_LIST);
  //   if (response.status) {
  //     console.log("email list:", response.data);
  //     setEmailList(response.data);
  //   } else {
  //   }
  // };
  const fetchEmailsForCluster = async () => {
    const response = await apiPost(API_ENDPOINT_FETCH_CLUSTOR_EMAIL_LIST, {
      workspace: userDetails?.currentWorkspace?.name,
    });

    if (response.status) {
      setEmailList(response.data);
    } else {
      // handle error if needed
    }
  };

  const fetchEmailCredentials = async (isAutoRefresh = false) => {
    if (!isAutoRefresh) setLoading(true);
  
    const response = await apiGet(API_ENDPOINT_FETCH_EMAIL_CREDENTIALS_LIST);
  
    if (response.status) {
      const newData = response.data?.credentials || [];
  
      const isSame = _isEqual(newData, tableData);
  
      if (!isSame) {
        
        if (isAutoRefresh) {
          // Check for rows that moved from FAILED_LOGIN to SUCCESS
          const movedToSuccess = newData.filter((newRow: any) => {
            const existingRow = originalData.find((row) => row.id === newRow.id);
            // Check if it was previously FAILED_LOGIN and now is SUCCESS
            const wasFailed = existingRow?.status === "FAILED_LOGIN";
            const isNowSuccess = newRow.status === "SUCCESS";
            return wasFailed && isNowSuccess;
          });

          if (movedToSuccess.length > 0) {
            setResolvedRows(movedToSuccess);
            setShowResolutionPopup(true);
          }
        }
        
        setTableData(newData);
        setOriginalData(_cloneDeep(newData));
      } else {
      }
    }
  
    if (!isAutoRefresh) setLoading(false);
  };
  
  

 

  const handleRowEdit = async (rowData: any) => {
    let emailPID: any = props.emailList.find(
      (item: any) => item.email === rowData.email
    );

    const response = await apiPost(API_ENDPOINT_EMAIL_CREDENTIAL_MAP, {
      workspace_id: rowData?.workspace_id,
      email_login_pid: emailPID?.email_login_pid,
      ssr_email: rowData?.ssr_email,
      pan: rowData?.pan,
    });
    if (response.status) {
      messageApi.success({
        type: "success",
        content: response.message,
      });
    } else {
      messageApi.error({
        type: "error",
        content: response.message,
      });
    }
  };

  const handleExportTableData = () => {

    if (gridRef.current && gridRef.current.exportDataToExcel) {
      gridRef.current.exportDataToExcel();
    }
  };
  const handleDownloadCsv = () => {
    if (!gridApiRef.current) return;

    const rowsToExport: any[] = [];

    // Collect only rows where ssr_email or email is null or empty
    gridApiRef.current.forEachNode((node: any) => {
      const { ssr_email, email } = node.data;
      const isSsrEmpty = !ssr_email || ssr_email.trim() === "";
      const isEmailEmpty = !email || email.trim() === "";

      if (isSsrEmpty || isEmailEmpty) {
        rowsToExport.push(node);
      }
    });

    // Temporarily select matching rows
    rowsToExport.forEach((node) => node.setSelected(true));

    // Export selected rows only
    gridApiRef.current.exportDataAsExcel({ onlySelected: true });

    // Deselect all after export
    gridApiRef.current.deselectAll();
  };

  const handleCellEditingStarted = (event: CellEditingStartedEvent) => {
    const saveBtn = document.getElementById("saveBtn");
    if (saveBtn) {
      //saveBtn.style.display = "inline-block";
      saveBtn.style.display = "flex";
      saveBtn.style.padding = "16px 40px";
      saveBtn.style.fontSize = "16px";
      saveBtn.style.borderRadius = "4px";
    }
  };

  const handleBulkUpdateClick = () => {
    setIsBulkModalVisible(true);
  };

  const handleUpload = async (file: any) => {
    const selectedFile = file.originFileObj || file;
    if (!file.originFileObj) {
      const reader = new FileReader();

      reader.onload = async (e: any) => {
        const binaryString = e.target.result;
        let jsonArray;

        if (file.type.includes("csv")) {
          //@ts-ignore
          jsonArray = await csv().fromString(binaryString);
        } else if (
          file.type.includes("sheet") ||
          file.type.includes("excel") ||
          file.name.endsWith(".xls") ||
          file.name.endsWith(".xlsx")
        ) {
          const workbook = XLSX.read(binaryString, { type: "binary" });
          const firstSheetName = workbook.SheetNames[0];
          const worksheet = workbook.Sheets[firstSheetName];
          jsonArray = XLSX.utils.sheet_to_json(worksheet);
        } else {
          return;
        }

        // Trim whitespace from each value in the JSON array
        jsonArray = jsonArray.map((row: any) => {
          return Object.fromEntries(
            Object.entries(row).map(([key, value]) => [
              key,
              typeof value === "string" ? value.trim() : value,
            ])
          );
        });

        setUploadedData(jsonArray);
        setUploadedFile(selectedFile);
      };

      reader.readAsBinaryString(file);
    }
  };

  const handleReUpload = () => {
    setUploadedFile(null);
  };

const handleSaveClick = async () => {
  if (!gridApi) return;

  const editableFields = ["email_password"];
  const modifiedRows: any[] = [];
  const verifiedRows: any[] = [];
  const keyField = "email_login_pid";



  gridApi.forEachNode((node: any) => {
    const pan = node.data[keyField];
    const isNew = node.data?.isNew === true;

    if (isNew) {
      modifiedRows.push(node.data);
      return;
    }

    const original = originalData.find((item) => item[keyField] === pan);
    if (!original) {
      return;
    }

    const isModified = editableFields.some((key) => {
      const newValue = (node.data[key] ?? "").toString().trim();
      const oldValue = (original[key] ?? "").toString().trim();
      if (!newValue && !oldValue) return false;
      const changed = newValue !== oldValue;
      if (changed) {
        console.log(
          `Field changed: ${key} | Old: '${oldValue}' -> New: '${newValue}'`
        );
      }
      return changed;
    });

    if (isModified) {
      modifiedRows.push(node.data);
    }
  });

  if (modifiedRows.length === 0) {
    messageApi.info("No changes to save.");
    return;
  }

  // Loop through modified rows and save
  for (const row of modifiedRows) {
    const addNewPayload = {
      email_login_pid: row.email_login_pid || null,
      workspace_id: userDetails?.currentWorkspace?.id,
      email: row.email,
      email_password: row.email_password,
      imap_host: row.imap_host || "imap.gmail.com",
      imap_port: parseInt(row.imap_port || "993"),
      gmail_app_password: row.gmail_app_password || null,
    };

    try {
      const addResponse = await axios.post(
        API_ENDPOINT_EMAIL_ADD_NEW,
        // "http://localhost:7001/api/creds/email/addNew",
        addNewPayload
      );
      verifiedRows.push(row); // ✅ push if success

    } catch (error) {
      messageApi.error(`${row.email} failed to save.`);
    }
  }

  if (verifiedRows.length === 0) {
    messageApi.warning("No valid credentials saved.");
    return;
  }

  // ✅ Update local table and UI after save
  const updatedData = tableData.map((row) => {
    const updated = verifiedRows.find((item) => item.email === row.email);
    return updated
      ? { 
          ...row, 
          email_password: updated.email_password, // 👈 force update latest password!
          isNew: false, 
          status: "PENDING" 
        }
      : row;
  });

  const newOriginal = _cloneDeep(updatedData);
  setOriginalData(newOriginal);
  setTableData(updatedData);
  gridApi.setRowData(updatedData);

  const saveBtn = document.getElementById("saveBtn");
  if (saveBtn) saveBtn.style.display = "none";

  messageApi.success("Changes saved successfully!");
  startAutoRefresh();
};



  const handleModalSubmit = async () => {
    if (uploadedData.length === 0) {
      messageApi.warning("No data uploaded");
      return;
    }

    try {
      const normalize = (val: any) =>
        (val ?? "").toString().trim().toLowerCase();
      const matchedData: any[] = [];
      const unmatchedRows: any[] = [];

      uploadedData.forEach((uploadedRow) => {
        const normalizedUploadedRow: Record<string, any> = {};
        Object.entries(uploadedRow).forEach(([key, val]) => {
          normalizedUploadedRow[key.toLowerCase()] = val;
        });

        // const match = tableData.find(
        //   (gridRow) =>
        //     normalize(normalizedUploadedRow['pan']) === normalize(gridRow.pan)
        // );
        const match = tableData.find(
          (gridRow) =>
            normalize(normalizedUploadedRow["pan number"]) ===
            normalize(gridRow.pan)
        );

        const emailMatch = props.emailList.find(
          (item: any) =>
            normalize(item.email) === normalize(normalizedUploadedRow["email"])
        );

        if (match) {
          matchedData.push({
            email_login_pid: emailMatch?.email_login_pid ?? null,
            pan: (normalizedUploadedRow["pan"] ?? match.pan ?? "")
              .toString()
              .trim(),
            email: (normalizedUploadedRow["email"] ?? match.email ?? "")
              .toString()
              .trim(),
            ssr_email: (
              normalizedUploadedRow["ssr email"] ??
              match.ssr_email ??
              ""
            )
              .toString()
              .trim(),
            workspace_id: match.workspace_id || match.workspaceId,
          });
        } else {
          unmatchedRows.push(normalizedUploadedRow);
        }
      });

      if (matchedData.length > 0) {
        const response = await axios.post(
          API_ENDPOINT_EMAIL_CREDENTIAL_MAPBULK,
          matchedData
        );

        messageApi.success("Bulk update successful!");

        if (response.data?.credentials) {
          setTableData(response.data.credentials);
          setOriginalData(_cloneDeep(response.data.credentials));
        }
      }

      setIsBulkModalVisible(false);
      setUploadedData([]);
    } catch (error) {
      messageApi.error("Bulk update failed.");
    }
  };

  const handleAddRow = () => {
    const newItem = {
      // id: uuidv4(),
      // gstin: "-",
      ssr_email: "-",
      email: "-",
      status: "EMPTY",
      isNew: true,
    };

    // gridRef.current &&
    //   gridRef.current?.api.applyTransaction({ add: [newItem] });
    setTableData((prevState: any) => [newItem, ...prevState]);
    setIsRowAdded(true); //new---
  };

  // const onGridReady = (params: any) => {
  //   console.log("Grid ready, saving api to ref");
  //   setGridApi(params.api);
  //   gridApiRef.current = params.api;
  // };

  useEffect(() => {
    if (gridRef.current) {
      setGridApi(gridRef.current.api);   // access api directly from ref
    }
  }, [gridRef.current]);

  

  useEffect(() => {
    const filtered = originalData.filter((item) => {
      const isSuccess = item.status === "SUCCESS";
      return activeSegment === "SUCCESS" ? isSuccess : !isSuccess;
    });

    setTableData(filtered);
  }, [activeSegment, originalData]);

  useEffect(() => {
    const filtered = originalData.filter((item) => {
      const isSuccess = item.status === "SUCCESS";
      return activeSegment === "SUCCESS" ? isSuccess : !isSuccess;
    });

    setTableData(filtered);
  }, [activeSegment, originalData]);

  const handleGlobalSearch = (searchValue: string) => {
    const trimmed = searchValue.trim().toLowerCase();
  
    if (!trimmed) {
      setTableData(originalData); // Reset to original data if input is empty
      return;
    }
  
    const filtered = originalData.filter((row) => 
      row?.workspace?.toLowerCase().includes(trimmed) ||
      row?.email?.toLowerCase().includes(trimmed) ||
      row?.gmail_app_password?.toLowerCase().includes(trimmed)
    );
  
    setTableData(filtered);
  };
  

  return (
    <div className="ScreenContainer">
      {props.componentType ? null : (
        <PageHeader
          title="Email Credentials"
          rightActions={
            <div>
              <Button
                type="primary"
                size="small"
                icon={<ExportOutlined />}
                onClick={handleExportTableData}
                style={{ marginRight: 12 }}
              >
                Export
              </Button>
              <Button
                type="primary"
                size="small"
                icon={<PlusOutlined />}
                onClick={() => setShowModal(true)}
              >
                Add Email
              </Button>
            </div>
          }
        />
      )}
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          marginBottom: "10px",
          marginTop: "10px",
        }}
      >
        <div style={{ paddingLeft: "10px" }}>
          <Segmented
            options={[
              { label: "Action Required", value: "FAILED" },
              { label: "No Action Required", value: "SUCCESS" },
            ]}
            value={activeSegment}
            onChange={(value) => {
              console.log(value); // logs "Active" or "Failed"
              setActiveSegment(value); // ✅ update renamed state
            }}
            size="small"
          /> 
      </div>
        
        <div style={{ display: 'flex', gap: '10px' }}>
        <Input
            placeholder="Search Workspace, PAN or SSR Email"
            value={globalSearch}
            onChange={(e:any) => {
              const value = e.target.value;
              setGlobalSearch(value);
              handleGlobalSearch(value);
            }}
            allowClear
            prefix={<SearchOutlined style={{ color: '#72747d' }} />}
            style={{ width: '300px', marginBottom: '10px', marginRight: '10px' }}
          />
          <Button
            id="saveBtn"
            type="primary"
            className="airlineSaveBtn"
            onClick={handleSaveClick}
            style={{ display: "none" }}
          >
            Save
          </Button>
          {/* 
          <Button id="bulkUpdateBtn"
            style={{
              padding: '16px 30px',
              borderRadius: '4px',
              color: '#FFF',
              fontSize: '16px',
              backgroundColor: '#0A8394',
              borderColor: '#0A8394',
              marginRight: '15px',
              //marginTop:'20px',
            }}
            className="airlineBulkBtn"
            onClick={handleBulkUpdateClick}
          >
            Bulk Update
          </Button> */}
        </div>
      </div>

      <div className="TableContainer">
        {isLoading ? (
          <Loader />
        ) : tableData.length === 0 ? (
          <div
            style={{
              display: "flex",
              alignItems: "center",
              width: "100%",
              height: "100%",
              justifyContent: "center",
            }}
          >
            <Empty />
          </div>
        ) : (
          <AgTableClient
            // @ts-ignore
            rowData={tableData}
            columnDefs={columnDefs}
            onRowSaved={handleRowEdit}
            footer={false}
            ref={gridRef}
            groupPanel
            showStatusBar
            autoResize
            singleClickEdit={true}
            enableDirectEdit
            onCellEditingStarted={handleCellEditingStarted}
            // onGridReady={onGridReady}
          />
        )}
      </div>

      <Modal
  title={isEditMode ? "Edit Email Credential" : "Add Email To Workspace"}
  open={showModal}
  footer={false}
  onCancel={handleModalClose}
  width={600}
>
  <div style={{ marginTop: "32px" }}>
    <CreateEmail
      onSuccess={handleCreateSuccess}
      onClose={handleModalClose}
      isEditMode={isEditMode}
      editData={editingData}
    />
  </div>
</Modal>

      <Modal
        title="Bulk Update"
        open={isBulkModalVisible}
        footer={null}
        onCancel={() => setIsBulkModalVisible(false)}
        width={500}
        style={{ width: 500 }}
      >
        <div style={{ display: "flex", justifyContent: "flex-end" }}>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              backgroundColor: "#e5f6f7",
              borderRadius: "4px",
              padding: "6px 12px",
              cursor: "pointer",
              width: "fit-content",
              marginBottom: "20px",
              marginTop: "20px",
            }}
            onClick={handleDownloadCsv}
          >
            <DownloadIcon
              style={{
                marginRight: "6px",
                color: "#0a8394",
                width: "14px",
                height: "18px",
              }}
            />
            <span style={{ color: "#0a8394", fontWeight: 500 }}>
              Download PAN list for credentials
            </span>
          </div>
        </div>

        {/* Upload or Uploaded file status */}
        {!uploadedFile ? (
          <Uploader onSelect={handleUpload} />
        ) : (
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
            }}
          >
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "10px",
                flexDirection: "column",
              }}
            >
              <DownloadDoneIcon
                style={{
                  color: "#008000",
                  fontSize: "20px",
                  width: "70px",
                  height: "80px",
                }}
              />
              {/* <span style={{ fontWeight: 500 }}>File uploaded: {uploadedFile.name}</span> */}
              <span style={{ fontWeight: 800, color: "" }}>File uploaded</span>
            </div>
            <span
              onClick={handleReUpload}
              style={{
                display: "flex",
                alignContent: "center",
                color: "#0a8394",
                cursor: "pointer",
                backgroundColor: "#e5f6f7",
                borderRadius: "4px",
                padding: "4px 6px",
                marginTop: "7px",
              }}
            >
              Repload <FileUploadIcon />
            </span>
          </div>
        )}

        <div
          style={{
            display: "flex",
            gap: "16px",
            justifyContent: "space-between",
            marginTop: "30px",
          }}
        >
          <Button
            onClick={() => setIsBulkModalVisible(false)}
            style={{
              padding: "17px 60px",
              justifyContent: "center",
              alignItems: "center",
              borderRadius: "8px",
              fontSize: "16px",
              color: "#0A8394",
              borderColor: "#0A8394",
            }}
          >
            Cancel
          </Button>
          <Button
            onClick={handleModalSubmit}
            //disabled={!uploadedFile}
            style={{
              padding: "18px 60px",
              justifyContent: "center",
              alignItems: "center",
              borderRadius: "8px",
              fontSize: "16px",
              color: "#FFF",
              backgroundColor: "#0A8394",
              //backgroundColor: uploadedFile ? '#0A8394' : '#ccc',
              //cursor: uploadedFile ? 'pointer' : 'not-allowed'
            }}
          >
            Submit
          </Button>
        </div>
      </Modal>
      <Modal
        title="🎉 Email Credentials Resolved!"
        open={showResolutionPopup}
        onCancel={() => setShowResolutionPopup(false)}
        footer={[
          <Button key="ok" type="primary" onClick={() => setShowResolutionPopup(false)}>
            Great!
          </Button>
        ]}
        width={500}
      >
        <div style={{ textAlign: 'center', padding: '20px 0' }}>
          <CheckCircleFilled style={{ fontSize: '48px', color: '#52c41a', marginBottom: '16px' }} />
          <h3>Action No Longer Required</h3>
          <p>The following email credentials have been successfully resolved:</p>
          <div style={{ marginTop: '16px', textAlign: 'left' }}>
            {resolvedRows.map((row, index) => (
              <div key={row.id} style={{ 
                padding: '8px 12px', 
                backgroundColor: '#f6ffed', 
                border: '1px solid #b7eb8f', 
                borderRadius: '4px', 
                marginBottom: '8px' 
              }}>
                <strong>{row.email}</strong> - {row.workspace}
              </div>
            ))}
          </div>
          <p style={{ marginTop: '16px', color: '#666' }}>
            These email credentials are now working properly and no longer require your attention.
          </p>
        </div>
      </Modal>
      {contextHolder}
    </div>
  );
}